import React, { FC } from 'react';
import TermsTemplate from './termsTemplate';

const DataPrivacyTermsPage: FC = () => {
  return <TermsTemplate termsDocument="dataPrivacy" />;
};

export default DataPrivacyTermsPage;
